import { Injectable } from '@jack-henry/frontend-utils/di';
import { ObservationSource } from '@jack-henry/frontend-utils/observable';

@Injectable()
export class LayoutService {
    private isSidebarOpen = false;

    private readonly sidebarOpenSource = new ObservationSource<boolean>();

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public readonly isSidebarOpen$ = this.sidebarOpenSource.toObservable();

    private displayLandscapeWarning = true;

    private readonly displayLandscapeWarningSource = new ObservationSource<boolean>();

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public readonly displayLandscapeWarning$ = this.displayLandscapeWarningSource.toObservable();

    public displayLandscapeWarningMessage(display = true) {
        this.displayLandscapeWarningSource.emit(display);
    }

    public toggleSidebar() {
        this.isSidebarOpen = !this.isSidebarOpen;
        this.sidebarOpenSource.emit(this.isSidebarOpen);
    }
}
